<template>
  <div class="info-change">
    <div class="row">
      <div class="col-6">
        <div class="form-group merged row">
          <label for="last_name" class="col-form-label col-4 d-flex align-items-center">
            {{ $t('account.last_name') }}
          </label>

          <div class="col-8">
            <input id="last_name"
                   type="text"
                   class="form-control"
                   v-model="info_change_form.data.last_name" disabled>
          </div>
        </div>
        <div class="form-group merged row">
          <label for="first_name" class="col-form-label col-4 d-flex align-items-center">
            {{ $t('account.first_name') }}
          </label>

          <div class="col-8">
            <input id="first_name"
                   type="text"
                   class="form-control"
                   v-model="info_change_form.data.first_name" disabled>
          </div>
        </div>

        <div class="form-group row">
          <label for="second_name" class="col-form-label col-4 d-flex align-items-center">
            {{ $t('account.second_name') }}
          </label>

          <div class="col-8">
            <input id="second_name"
                   type="text"
                   class="form-control"
                   v-model="info_change_form.data.second_name" disabled>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="info-block">
          <span class="header"> {{ $t('account.info.header') }}</span>
          <span class="phone">
<!--                        {{ $t('account.info.call') }}:<br/>-->
                        <a href="tel:0487300030" class="phone">
                            +38 (048) 730-00-30
                        </a>
                    </span>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label for="patient_id" class="col-form-label col-2 d-flex align-items-center">
        {{ $t('account.cart_number') }}
      </label>
      <div class="col-4">
        <input id="patient_id"
               type="text"
               class="form-control"
               v-model="patient.id" disabled>
      </div>
    </div>

    <div class="form-group row">
      <label for="birthday" class="col-form-label col-2 d-flex align-items-center">
        {{ $t('account.birthday') }}
      </label>
      <div class="col-4">
        <input id="birthday"
               type="text"
               class="form-control"
               v-model="info_change_form.data.birthday" disabled>
      </div>

      <div class="additional-info col-form-label col-4 d-flex align-items-center">
        {{ $t('account.age') }}: {{ formatDateNow(info_change_form.data.birthday) }}
      </div>
    </div>

    <h3>{{ $t('account.contacts') }}</h3>

    <div class="form-group merged row">
      <label for="phone" class="col-form-label col-2 d-flex align-items-center">
        {{ $t('account.phone') }}
      </label>

      <div class="col-4">
        <input id="phone"
               type="text"
               class="form-control"
               v-model="info_change_form.data.phone" disabled>
      </div>
    </div>

    <div class="form-group  row">
      <label for="email" class="col-form-label col-2 d-flex align-items-center">
        E-mail
      </label>

      <div class="col-4 d-flex flex-row" :class="!info_change_form.data.email_confirmed ? 'not-confirmed-email-icon': ''">
        <input id="email"
               type="text"
               class="form-control"
               v-model="user.email" disabled>
      </div>

      <div class="col-5 d-flex" v-if="patient.primary_patient">
        <div class="d-flex flex-row" v-if="!sending">
          <p @click.prevent="showEditModal()" class="change-email mb-0">{{ $t('buttons.change_email') }}</p>
        </div>
        <div class="d-flex flex-row" v-else>
          <b-spinner
              variant="primary"
          ></b-spinner>
        </div>
      </div>

    </div>

    <div class="form-group row">
      <label for="address" class="col-form-label col-2 d-flex align-items-center">
        {{ $t('account.address') }}
      </label>

      <div class="col-4">
                <textarea id="address"
                          type="text"
                          class="form-control"
                          rows="4"
                          v-model="info_change_form.data.address" disabled></textarea>
      </div>
    </div>
    <div class="form-group row">
      <label for="language" class="col-form-label col-2 d-flex align-items-center">
        {{ $t('account.language') }}
      </label>

      <div class="col-4">

        <v-select v-model="systemLanguage"
                  :options="languages"
                  id="language"
                  @input="changeLanguage()"
                  label="languageName"
                  :searchable="false">
        </v-select>
      </div>
    </div>
    <b-modal ref="emailEditModal" centered size="md" hide-footer :title="$t('buttons.change_email')">
      <div class="form-group">
        <label for="new-email" class="col-form-label col-12 d-flex align-items-center">
          {{ $t('account.new_email') }}
        </label>
        <div class="col-12 mb-5">
          <input
              :class="{ 'invalid': info_change_form.data.email !== null && $v.info_change_form.data.email.$error }"
              id="new-email"
              type="text"
              class="form-control"
              v-model="info_change_form.data.email">
        </div>
        <div class="col-12">
          <button class="btn btn-block btn-secondary py-2 text-white" :disabled="sending" @click="confirmEmail()">
            {{ $t('buttons.change') }}
          </button>
        </div>


      </div>
    </b-modal>
    <b-modal ref="emailNotConfirm" centered size="sm" hide-footer hide-header noCloseOnBackdrop>
      <div class="col-12 d-flex justify-content-center my-3">
        <Logo/>
      </div>
      <div class="col-12 mb-3">
        <p class="text-center">{{ $t('account.not_confirmed_email') }}</p>
      </div>
      <div class="col-12 mb-3">
        <button class="btn btn-block btn-secondary py-2 text-white" @click="hideEmailNotConfirm()">
          OK
        </button>
      </div>
    </b-modal>
    <b-modal ref="emailConfirmSent" centered size="md" hide-footer hide-header noCloseOnBackdrop>
      <div class="col-12 d-flex justify-content-center my-3">
        <Logo/>
      </div>
      <div class="col-12 mb-3">
        <p class="text-center" v-html="$t('account.confirmation_sent')"></p>
      </div>
      <div class="col-12 mb-3">
        <button class="btn btn-block btn-secondary py-2 text-white" @click="hideEmailConfirmSent">
          OK
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {email, required} from 'vuelidate/lib/validators';
import moment from 'moment';
import config from '@/helpers/configDateFormats';

import DateInput from '../../components/DateInput';
import PhoneInput from '../../components/PhoneInput';
import confirmEmail from "@/api/user/confirmEmail";
import Logo from "@/components/Logo";

export default {
  name: 'info-change',
  data() {
    return {
      info_change_form: {
        data: {
          last_name: null,
          first_name: null,
          second_name: null,
          birthday: null,
          phone: null,
          email: null,
          address: null,
          email_confirmed: null,
        },
        errors: {},
        success: null,
        loading: false,
      },
      languages: [
        {languageName: 'Русский', languageCode: 'ru'},
        {languageName: 'Українська', languageCode: 'ua'},
      ],
      systemLanguage: null,
      emailEdit: false,
      sending: false,
    };
  },
  validations: {
    info_change_form: {
      data: {
        email: {
          email,
          required
        }
      }
    }
  },
  methods: {
    hideEmailConfirmSent() {
      this.$store.dispatch('getUserInfo').then(response => {
        this.info_change_form.data.email_confirmed = false
        this.$refs.emailConfirmSent.hide();
      })
    },
    hideEmailNotConfirm() {
      this.$refs.emailNotConfirm.hide();
      this.$refs.emailConfirmSent.show();
    },
    formatDateNow(date) {
      return moment(date,config.DATE_FORMAT).fromNow(true);
    },
    changeLanguage(val) {
      if (this.language !== this.systemLanguage.languageCode) {
        this.$store.dispatch('setLanguage',{language:this.systemLanguage.languageCode,reload:true} )
      }
    },
    showEditModal() {
      this.$refs.emailEditModal.show()
    },
    confirmEmail() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return false
      }
      this.sending = true
      confirmEmail(this.info_change_form.data).then(() => {
        this.sending = false
        this.$refs.emailEditModal.hide()
        this.$refs.emailNotConfirm.show();
      })
    }
  },
  computed: {
    ...mapGetters([
      'patient',
      'user',
      'language'
    ]),

  },
  mounted() {
    this.systemLanguage = this.languages.find(item => item.languageCode === this.language)
    if (this.patient) {
      const [last_name = null, first_name = null, second_name = null] = this.patient.name.split(' ');

      this.info_change_form.data = {
        ...this.info_change_form.data,
        last_name: last_name,
        first_name: first_name,
        second_name: second_name,
        birthday: moment(this.patient.birthday).format(config.DATE_FORMAT),
        phone: this.user.phone,
        email: this.user.email,
        address: this.patient.address,
        email_confirmed: this.user.email_confirmed,
      }
    }
  },
  components: {
    Logo
  }
}
</script>

<style lang="scss">
.info-change {
  padding-top: 30px;

  & > .row {
    margin-bottom: 15px;

    &:last-child {
      margin-top: 20px;
    }

    & > .additional-info {
      font-size: 15px;
      color: #7c98a6;
    }

    .v-select {
      background: #E9ECEF;

      .dropdown-toggle {
        height: 50px;
        padding: 6px 12px;

        .open-indicator {
          bottom: calc(25% - 3px);
        }
      }

      .clear {
        display: none;
      }

    }

    .change-email {
      font-size: 18px;
      line-height: 22px;
      color: #0084B6;
      cursor: pointer;
      padding-top: 13px;
    }

    .not-confirmed-email-icon:after {
      content: '';
      width: 20px;
      height: 20px;
      position: absolute;
      top: 25%;
      right: 25px;
      background-image: url('~@/assets/images/icon_exclamation.svg');
    }
  }

  & .merged {
    margin-bottom: -1px;

    input {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    & + .form-group {
      input {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }

      textarea {
        resize: none;
      }
    }
  }

  & > h3 {
    font-size: 15px;
    font-weight: bold;
    margin-top: 40px;
    margin-bottom: 20px;
  }

  & .info-block {
    max-width: 220px;
    padding: 20px;

    box-shadow: 0 2px 4px -1px rgba(163, 190, 204, 0.5), 0 0 0 1px rgba(163, 190, 204, 0.2);
    border-radius: 5px;

    & .header {
      font-size: 15px;
      font-weight: bold;
      color: #0a4766;
      margin-bottom: 10px;
    }

    & .phone {
      font-size: 18px;
      color: #0a4766;
    }
  }
}
</style>
